export const START_OPTION = {
  DAILY: "daily",
  LESSON_NUMBER: "lessonNumber",
};

export const DEFAULT_START_OPTION = START_OPTION.DAILY;

export const LESSON_NUMBER_LIMITS = {
  MIN: 1,
  MAX: 365,
};
